<template>
    <div class="reference-list">
        <div class="container">
            <div class="title">
                <span @click="visible = !visible" class="toggle-list" href="/" role="button" aria-label="Toggle reference list visibility">
                    <font-awesome class="icon-chevron" :class="[visible ? '' : 'fa-rotate-180']" icon="chevron-up" />
                </span>
                {{ data.title }}
            </div>
            <ul v-show="visible">
                <Reference v-for="model in referenceModels" :model="model" />
            </ul>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { ReferenceListModel, ReferenceModel } from '~/models';

const pageStore = usePageStore()

const visible = computed({
  get: () => pageStore.referenceListVisible,
  set: (val) => pageStore.referenceListVisible = val
})

const referenceModels = ref<ReferenceModel[]>([])
const props = defineProps<{ model: ReferenceListModel }>()

const references = pageStore.getPageReferences()
referenceModels.value = Object.values(references) as ReferenceModel[]

const data = {
  title: props.model.elements.title.value,
}

</script>
